const VERSION = '2.4.0';
export function getVersionString() {
    return VERSION;
}